var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.onalert
        ? _c("modal-alert", {
            attrs: {
              onalert: _vm.onalert,
              alert: _vm.alert,
              number: _vm.number,
              count: _vm.count,
            },
            on: {
              onclose: function ($event) {
                _vm.onalert = false
              },
              confirm: _vm.CONFIRM,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bg-surface-secondary w-100" }, [
        _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
          _c("div", { staticClass: "container-fluid py-3" }, [
            _c("div", { staticClass: "row align-items-center" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                  _c("div", [
                    _c("button", {
                      staticClass: "btn-close text-xs",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.go(-1)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vr opacity-20 my-1" }),
                  _vm._v(" "),
                  _c("div", [
                    _c("h1", { staticClass: "h4 ls-tight" }, [
                      _vm._v("Ruta de Entrega"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-sm text-muted mb-0" }, [
                      _vm._v("Documento de Entrega #"),
                      _c("b", [_vm._v(_vm._s(_vm.data.id))]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
          _c("div", { staticClass: "container-fluid vstack gap-5" }, [
            _vm.data.state_id == 25
              ? _c("div", { staticClass: "card" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", [
                      _c(
                        "form",
                        {
                          staticClass: "d-flex gap-3 row",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.SEARCH()
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-lg-11 col-sm-10 col-9 px-0" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "input-group input-group-inline",
                                },
                                [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.number,
                                        expression: "number",
                                      },
                                    ],
                                    ref: "number",
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Buscar...",
                                    },
                                    domProps: { value: _vm.number },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.number = $event.target.value
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn px-3 btn-primary",
                                attrs: {
                                  type: "submit",
                                  disabled: !_vm.number,
                                },
                              },
                              [
                                _vm.loading == "search"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "spinner-border spinner-border-sm",
                                        attrs: { role: "status" },
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Loading..."),
                                        ]),
                                      ]
                                    )
                                  : _c("span", [_vm._v("Buscar")]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.loading == "data"
              ? _c("div", { staticClass: "w-100 py-3" }, [_vm._m(2)])
              : _c("div", { staticClass: "card" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body p-0" },
                    [
                      _vm.data.packages.length > 0
                        ? [
                            _c("v-data-table", {
                              staticClass: "elevation-1 table-sm",
                              attrs: {
                                headers: _vm.headers.filter(function (e, i) {
                                  if (_vm.data.state_id == 25) {
                                    return e
                                  } else {
                                    if (i >= 0) {
                                      return e
                                    }
                                  }
                                }),
                                items: _vm.data.packages,
                                dense: "",
                                "show-select": _vm.data.state_id == 25,
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.data.state_id == 25
                                    ? {
                                        key: "item.data-table-select",
                                        fn: function (ref) {
                                          var item = ref.item
                                          var isSelected = ref.isSelected
                                          var select = ref.select
                                          return [
                                            _c("v-simple-checkbox", {
                                              attrs: {
                                                ripple: false,
                                                value: isSelected,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return select($event)
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                      }
                                    : null,
                                  {
                                    key: "item.user.address_or_branch",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              item.user.address_or_branch
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.route",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.data.route.full_name) +
                                            "\n                                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "text-decoration-none",
                                            attrs: {
                                              to: {
                                                name: "PackageUpdate",
                                                params: { id: item.id },
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(item.type) +
                                                _vm._s(item.id) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.selected,
                                callback: function ($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                          ]
                        : _c("div", { staticClass: "w-100 py-3" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-sm text-muted text-center mb-0",
                              },
                              [_vm._v("No hay resultados.")]
                            ),
                          ]),
                    ],
                    2
                  ),
                ]),
            _vm._v(" "),
            _vm.data.packages.length > 0 && _vm.data.state_id == 25
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-h px-3 btn-danger",
                        attrs: {
                          type: "button",
                          disabled: _vm.selected.length == 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.REMOVE()
                          },
                        },
                      },
                      [
                        _vm.loading == "remove"
                          ? _c(
                              "div",
                              {
                                staticClass: "spinner-border spinner-border-sm",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Loading..."),
                                ]),
                              ]
                            )
                          : _c("span", [
                              _c("b", [_vm._v("-")]),
                              _vm._v(" Quitar seleccionados"),
                            ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Ruta de Entrega")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _vm._v("GV"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Paquetes Agregados")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }